<template>
    <div class="supplier_orders pb-3">
<v-alert outlined text dense color="purple"> この画面は作成中です。</v-alert>

      <table class="purchase_summary">
        <thead>
        <tr>
          <th class="text-left caption"> 年月 </th>
          <th class="text-left caption">  仕入額 </th>
          <th class="text-left caption">  納期達成率 </th>
        </tr>
        </thead>
        <tbody>
        <tr class="body-2">
          <td> 2020年8月度 </td>
          <td> 230,000円</td>
          <td> 78%</td>
        </tr>
        <tr class="body-2">
          <td> 2020年9月度 </td>
          <td> 180,000円</td>
          <td> 99%</td>
        </tr>
        <tr class="body-2">
          <td> 2020年10月度 </td>
          <td> 213,000円</td>
          <td> 100%</td>
        </tr>
        </tbody>
      </table>

      <v-simple-table dense>
        <template v-slot:default>
        <thead>
          <tr class=""> 
            
            <th>発注No</th>
            <th>品番</th>
            <th>工程</th>
            <th>発注数</th>
            <th>納期</th>
            <th>仕入日</th>
            <th>状態</th>
          </tr>
          <tr class="">           
            <th>発注日</th>
            <th colspan="2">品名</th>
            <th>発注残</th>
            <th>納期回答</th>
            <th colspan="2">品番担当</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="order in orderList">
            <tr :key="order.orderNo">
              <td style="border:none;">{{ order.orderNo }}</td>
              <td style="border:none;">{{ order.itemFullCd }}</td>
              <td style="border:none;">{{ order.processName }}</td>
              <td style="border:none;">{{ order.quantityOrder }}</td>
              <td style="border:none;">{{ formatDateToDisplay(order.deliveryDate) }}</td>
              <td style="border:none;">{{ formatDateToDisplay(order.purchaseDate) }}</td>
              <td style="border:none;">
              <!-- <span v-if="条件を書く"> なんでも書ける </span>  -->  
              <span v-if="order.status == 0">未納</span>
              <span v-else-if="order.status == 1">分納</span>
              <span v-else-if="order.status == 2">完納</span>
              <span v-else>他({{order.status}})</span>
              </td>
            </tr>
            <tr :key="order.orderNo"> 
              <td>{{ formatDateToDisplay(order.orderDate) }}</td>
              <td colspan="2">{{ order.itemName }}</td>
              <td>{{ order.undelivererOrder }}</td>
              <td>{{ formatDateToDisplay(order.answerDate) }}</td>
              <td colspan="2">{{ order.itemPersonName}}</td>
            </tr>
          </template>
        </tbody>
        </template>
      </v-simple-table >


    </div>
</template>
<script>

import ObjectParamSupport from "@/components/ObjectParamSupport";
import BaseView from "../../components/BaseView";
import SupplierAPI from "@/apis/SupplierAPI";

export default {
    mixins:[ObjectParamSupport,BaseView],
    components: {

    },
    props: {
        supplierId: Number
    },
    data: () => ({
      isInitialized:false,
      isFetched:false,
      isLoading:false,
      isDownloading:false,

      condition:{},

      orderList:[
        {
          "supplierId": 0,
          "systemCd": "3041",
          "orderNo": "1",
          "orderDate": "2021-07-01T00:00:00",
          "itemFullCd": "11111-12-000",
          "itemCd": "11111",
          "itemRevNo": "12",
          "itemSubCd": "000",
          "itemName": "テスト品番",
          "processName": "購入",
          "deliveryDate": "2021-07-12T00:00:00",
          "answerDate": "2021-07-13T00:00:00",
          "quantityOrder": 12,
          "undelivererOrder": 12,
          "purchaseDate": null,
          "itemPersonCd": "060",
          "itemPersonName": "きのさん",
          "status": 0
        },
        
      ],


      pager:{},
      errors:{},
    }),
    computed: {

    },
    mounted:function() {
        this.setupConditions();
    },
    created:function() {
    },
    watch: {
        '$route':function (to, from) {
            this.setupConditions();
        },
    },
    methods: {
      // ここにメソッドを書く↓↓↓↓

        setupConditions(){
            let p = this.getObjectParam();
            if (p){
                // パラメータの転写
                
            }

            this.fetchData(true)


            console.log("オーダー画面のsupplierId=",this.supplierId);
        },

        fetchData(needDataFetch){

            let supplierId = this.supplierId;

            let self = this;
            if (!this.isInitialized){
                this.fetchBasicData(function () {
                    self.fetchData(needDataFetch)
                });
                return;
            }
            if (needDataFetch){
                this.isLoading = true;
                Promise.resolve()
                    .then(a => SupplierAPI.getOrders(supplierId))
                    .then(data => {
                  
                        this.makeDisplayData(data);
                    })
                    .catch(function(err) {
                        console.log(err);
                        self.showErrorToast("データの取得に失敗しました。");
                    });
            }
            
        },
             
        fetchBasicData(finishProc){
            this.isInitialized = true;
            if (finishProc){
                finishProc();
            }
        },

        makeDisplayData(data) {

          this.logger.log("makeDisplayData", data)

          this.orderList.splice(0) // もともと入ってた値をクリアする
        
          data.forEach(rec => { // dataをグルグル回す
            
            //let supplier = rec; // 変数に保存
            rec.isNew = true;
            this.orderList.push(rec) // 表示用の配列に追加

          });
        }
      // ここにメソッドを書く↑↑↑↑
    },

}
</script>
<style lang="scss" scoped>
table.purchase_summary {
  border-color: gray;

  thead{
    border-color: inherit;
    th {
      font-weight: bold;
      color: gray;
    }
  }

  td,th {
    padding-right: 1em;
    padding-left: 1em;
    border-bottom-width: thin;
    border-bottom-style: solid;
    border-bottom-color: rgba(0,0,0,0.12);
  }
}
</style>